import React from 'react';
import {connect} from 'react-redux';
import FullWidthPage from '../Presentation/FullWidthPage';
import Page from '../Containers/Page';
import UserPackages from '../Containers/UserPackages';
import CurrentPackage from '../Containers/CurrentPackage';
import Talisman from '../Presentation/Talisman';
import {Link} from 'react-router';
// import SectionTitle from '../Presentation/SectionTitle';
// import CategoryPackages from '../Containers/CategoryPackages';

class HomePage extends React.Component {

    render() {
        if (this.props.authenticated) {
            return <FullWidthPage>

                <CurrentPackage />

                {/*<section className="section-daily-exercises col-md-8 col-md-offset-2">*/}
                {/*<SectionTitle>Мини ежедневни упражнения</SectionTitle>*/}
                {/*<p>Поредица от кратки ежедневни упражнения, които можеш да вмъкнеш в натоварения си график.</p>*/}
                {/*<div className="steps">*/}
                {/*<div className="step fade-in one">*/}
                {/*<div className="step-icon" />*/}
                {/*<h3>Отпусни се</h3>*/}
                {/*</div>*/}
                {/*<div className="step fade-in two">*/}
                {/*<div className="step-icon" />*/}
                {/*<h3>Фокусирай се</h3>*/}
                {/*</div>*/}
                {/*<div className="step fade-in three">*/}
                {/*<div className="step-icon" />*/}
                {/*<h3>Дишай</h3>*/}
                {/*</div>*/}
                {/*</div>*/}
                {/*</section>*/}

                <UserPackages className="col-md-offset-2 col-md-8" />

                {/*<CategoryPackages hideDescription={true} slug="onetime" limit={3} />*/}

                <Talisman />
            </FullWidthPage>
        }

        else {
            return <Page>
                <section className="top-section">
                    <div className="text-center container">
                        <h1>Силата и спокойствието са в теб</h1>
                        <p>Открий ги с Медита</p>
                        <div className="top-img-holder">
                            <div className="bg-circle"/>
                            <img className="img-responsive" src="/img/top-image.png" alt="top image"/>
                            <div className="subscribe-holder">
                                <div className="cloud-text">
                                    Усети спокойствието
                                    <Link to="/login" className="btn btn-red">Вход</Link>
                                </div>
                            </div>
                            <div className="register-holder">
                                <div className="cloud-text">
                                    Включи се безплатно
                                    <Link to="/register" className="btn btn-red">Регистрация</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="about-section">
                    <div className="container">
                        <div className="row">
                            <div className="text-center col-md-12">
                                <h2>Научи се да медитираш и да живееш осъзнато</h2>
                            </div>
                            <div className="col-md-10 col-md-offset-1">
                                <ul>
                                    <li>Безплатен пакет от 7 медитации за новорегистрираните</li>
                                    <li>Десетки сесии от различно естество</li>
                                    <li>Еднократни сесии за хора с натоварен график</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="stress-relief">
                    <div className="container text-center">
                        <h2>Неспокоен си?</h2>
                        <p>Ежедневните медитации помагат за намаляване нивото на стреса и внасят спокойствие и хармония в живота ти.</p>
                        <Link className="btn btn-default green" to="/register">Регистрация</Link>
                    </div>
                </section>
                <section className="losing-focus">
                    <div className="container">
                        <h2>Лесно губиш фокус?</h2>
                        <p>Доказано е, че ежедневните медитации подобряват концентрацията. Намали страничните разсейвания и повиши фокуса и ефективността си.</p>
                        <Link className="btn btn-default pink" to="/register">Регистрация</Link>
                    </div>
                </section>
                <section className="test-medita">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <img className="img-responsive medita-app" src="/img/medita-app.png" alt="Medita app"/>
                            </div>
                            <div className="col-md-8 col-md-offset-1">
                                <h2>Изтегли приложението на Медита.бг</h2>
                                <a className="btn btn-default" href="https://play.google.com/store/apps/details?id=bg.mobio.medita" target="_blank">Android</a>
                                <a className="btn btn-default" href="https://apps.apple.com/us/app/medita-bg/id1463152371?ls=1" target="_blank">iOs</a>
                            </div>
                        </div>
                    </div>
                </section>
            </Page>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        oneTimePackages: state.packages.oneTimePackages,
        userPackages: state.packages.userPackages,
        authenticated: state.auth.authenticated
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(HomePage);




// WEBPACK FOOTER //
// ./src/components/Pages/Home.js